export * from "./userConstants";
export * from "./propertyConstants";

export const displayFooterConstants = {
  DISPLAY: 'FOOTER_DISPLAY',
};
